/**
 * Create a meta-tag element
 * @param {string} propertyName The property name
 * @param {string} content The content of meta-tag
 * @example setSocialMetaTag('og:title', 'Foo title')
 */
export const setSocialMetaTag = (propertyName, content = '') => {
  const metaExist = document.querySelector(`meta[property="${propertyName}"]`);
  if (metaExist) return;

  const metaEl = document.createElement('meta');
  metaEl.setAttribute('property', propertyName);
  metaEl.setAttribute('content', content.replace(/<[^>]*>?/gm, ''));

  document.getElementsByTagName('head')[0].appendChild(metaEl);
};

/**
 * Update the content of a meta-tag
 * @param {string} propertyName The property name
 * @param {string} content The new content of meta-tag
 * @example updateSocialMetaTag('og:title', 'Foo title')
 */
export const updateSocialMetaTag = (propertyName, content) => {
  const metaExist = document.querySelector(`meta[property="${propertyName}"]`);
  if (!metaExist) return;
  metaExist.setAttribute('content', content.replace(/<[^>]*>?/gm, ''));
};

/**
 * Get the full path of an asset
 * @param {string} fileName The file name with extension
 * @returns The complete url or empty
 */
export const getFullPathAsset = (fileName) => {
  if (!fileName) return '';
  return `${process.env.VUE_APP_ASSET_PATH}${fileName}`;
};
